const initProductSingle2025 = () => {
	// The 2026 hero, or the 2025 hero the gift card PDP still renders
	const productHero = document.querySelector(
		".product-hero, .product-hero-2026"
	);

	if (!productHero) return;

	on("body", "click", ".js-bis-close", (e) => {
		const bis = e.target.parentElement.querySelector(".js-product-bis");

		if (bis) {
			bis.classList.remove("is-active");
		}
	});

	const initGiftCard = () => {
		// gift card product template
		const giftCard = document.querySelector(
			".product-hero .js-recipient-form, .product-hero-2026 .js-recipient-form"
		);

		if (!giftCard) return;

		on("body", "click", ".js-show-recipient", (e) => {
			if (e.target.checked) {
				giftCard.classList.add("is-active");
			} else {
				giftCard.classList.remove("is-active");
			}
		});

		on("body", "click", ".js-gift-card-recipient-close", (e) => {
			giftCard.classList.remove("is-active");
		});

		document.addEventListener("keydown", (e) => {
			if (e.key == "Escape") {
				giftCard.classList.remove("is-active");
			}
		});

		// force user to select current date
		const recipientForm = giftCard.querySelector("form");
		const recipientDate = giftCard.querySelector(".js-recipient-date");

		let today = new Date();
		let dd = today.getDate();
		let mm = today.getMonth() + 1; // January is 0
		let yyyy = today.getFullYear();
		if (dd < 10) {
			dd = "0" + dd;
		}
		if (mm < 10) {
			mm = "0" + mm;
		}
		today = yyyy + "-" + mm + "-" + dd;
		recipientDate.setAttribute("min", today);

		on("body", "input", ".js-recipient-date", (e) => {
			setTimeout(() => {
				if (e.target.value < today) {
					recipientForm.reportValidity();
					recipientDate.classList.add("invalid");
				} else if (dateDiff(today, e.target.value) > 90) {
					// Send on must be within 90 days from now
					// https://shopify.dev/docs/themes/product-merchandising/gift-cards#limitations
					recipientDate.setCustomValidity(
						"Send on must be within 90 days from now"
					);
					recipientForm.reportValidity();
					recipientDate.classList.add("invalid");
				} else {
					recipientDate.setCustomValidity("");
					recipientDate.classList.remove("invalid");
				}
			}, 600);
		});
	};
	initGiftCard();

	const initProductTechRangeBar = () => {
		const bars = document.querySelectorAll(".js-pdp-range-bar");
		if (!bars.length) return;
		const DEFAULT_GAP = 8;

		document
			.querySelectorAll(".js-pdp-range-bar-stripes")
			.forEach((stripes) => {
				// Clear previously appended stripes
				stripes.innerHTML = "";

				const stripeTemplate = document.createElement("span");
				stripeTemplate.className = "js-pdp-range-bar-stripe";

				const stripesWidth = stripes.getBoundingClientRect().width;
				const stripeCount = Math.round(stripesWidth / DEFAULT_GAP);

				const isActive = stripes.classList.contains("is-active");
				const DEFAULT_BORDER = isActive ? 2 : 1;
				const MAX_BORDER = DEFAULT_BORDER * 1.7;

				// Define ramp and peak sections for thickness animation
				const center = Math.floor(stripeCount / 2);
				const startRamp = Math.floor(stripeCount * 0.05);
				const endRamp = Math.floor(stripeCount * 0.95);
				const peakStart = center - 1;
				const peakEnd = center + 1;
				const rangeIn = peakStart - startRamp;
				const rangeOut = endRamp - peakEnd;

				// Use a document fragment for performance
				const fragment = document.createDocumentFragment();

				for (let i = 0; i < stripeCount; i++) {
					const cloneStripe = stripeTemplate.cloneNode(true);
					let thickness = DEFAULT_BORDER;

					if (isActive) {
						if (i >= startRamp && i < peakStart && rangeIn > 0) {
							// Increasing
							const t = (i - startRamp) / rangeIn;
							thickness = DEFAULT_BORDER + (MAX_BORDER - DEFAULT_BORDER) * t;
						} else if (i >= peakStart && i <= peakEnd) {
							// Peak
							thickness = MAX_BORDER;
						} else if (i > peakEnd && i <= endRamp && rangeOut > 0) {
							// Decreasing
							const t = 1 - (i - peakEnd) / rangeOut;
							thickness = DEFAULT_BORDER + (MAX_BORDER - DEFAULT_BORDER) * t;
						}
					}

					cloneStripe.style.setProperty(
						"--thickness",
						`${thickness.toFixed(2)}px`
					);

					fragment.appendChild(cloneStripe);
				}
				stripes.appendChild(fragment);
			});
	};
	window.addEventListener("load", initProductTechRangeBar);
	// A colour swap re-renders the tech section with empty stripe rows.
	document.addEventListener("bandit:product-swapped", initProductTechRangeBar);
	window.addEventListener(
		"resize",
		() => {
			// Debounce to prevent frequent DOM ops on resize
			clearTimeout(window.__resizeStripeTimer);
			window.__resizeStripeTimer = setTimeout(initProductTechRangeBar, 200);
		},
		{ passive: true }
	);
};

initProductSingle2025();

// Behaviour for snippets/product-hero-2026.liquid: gallery lightbox
// (snippets/pdp-lightbox.liquid), "+" cursor follower and the "Wear it with"
// related rail.
const initProductHero2026 = () => {
	let hero = document.querySelector(".js-pdp-hero-2026");
	if (!hero) return;

	root.classList.add("has-pdp-hero-2026");

	// A colour swap (productSwap in assets/js-shopify.js) replaces the whole hero,
	// lightbox included. Every handler below is bound once and reads these, so
	// re-point them at the new nodes rather than binding a second set.
	let gallery = null;
	let lightbox = null;
	let lightboxStack = null;
	let lightboxThumbs = null;
	let lightboxNav = null;
	let lightboxCurrent = null;
	let lightboxTotal = null;

	const bindHeroNodes = () => {
		hero = document.querySelector(".js-pdp-hero-2026");
		gallery = hero?.querySelector(".js-pdp-hero-2026-gallery");
		lightbox = document.querySelector(".js-pdp-lightbox");
		lightboxStack = lightbox?.querySelector(".js-pdp-lightbox-stack");
		lightboxThumbs = lightbox?.querySelector(".js-pdp-lightbox-thumbs");
		lightboxNav = lightbox?.querySelector(".js-pdp-lightbox-nav");
		lightboxCurrent = lightbox?.querySelector(".js-pdp-lightbox-current");
		lightboxTotal = lightbox?.querySelector(".js-pdp-lightbox-total");
	};
	bindHeroNodes();

	// ------------------------------------------------------------- Band colour
	// A photo narrower than the gallery frame is shown whole, with a band either
	// side (styles/_p-product-hero-2026.scss). The bands take the photo's own
	// backdrop grey, read from the outer columns of a 24px-wide copy of it
	// (`data-band-sample`, snippets/product-hero-image-2026.liquid). When most of
	// that edge is not backdrop — a close-up the fabric runs off — the bands keep
	// the stylesheet's fixed grey instead of turning dark.
	//
	// Sampled only once the slide's own image has loaded, so the 1–2KB copy never
	// competes with it.
	const isBackdropPixel = (red, green, blue) =>
		Math.max(red, green, blue) - Math.min(red, green, blue) <= 16 &&
		(red + green + blue) / 3 >= 170;

	const sampleBandColor = async (wrapper) => {
		if (wrapper.dataset.bandSampled) return;
		wrapper.dataset.bandSampled = "true";

		try {
			const response = await fetch(wrapper.dataset.bandSample);
			const bitmap = await createImageBitmap(await response.blob());
			const canvas = document.createElement("canvas");
			canvas.width = bitmap.width;
			canvas.height = bitmap.height;
			const context = canvas.getContext("2d");
			context.drawImage(bitmap, 0, 0);

			const totals = [0, 0, 0];
			let edgeCount = 0;
			let backdropCount = 0;
			for (const x of [0, bitmap.width - 1]) {
				const { data } = context.getImageData(x, 0, 1, bitmap.height);
				for (let i = 0; i < data.length; i += 4) {
					edgeCount++;
					if (!isBackdropPixel(data[i], data[i + 1], data[i + 2])) continue;
					backdropCount++;
					totals[0] += data[i];
					totals[1] += data[i + 1];
					totals[2] += data[i + 2];
				}
			}
			if (backdropCount < edgeCount / 2) return;

			const [red, green, blue] = totals.map((total) =>
				Math.round(total / backdropCount)
			);
			wrapper.style.setProperty("--band-color", `rgb(${red} ${green} ${blue})`);

			// A lightbox image read while it is on screen repaints the lightbox.
			if (
				wrapper.classList.contains("is-active") &&
				lightbox?.contains(wrapper)
			) {
				paintLightbox();
			}
		} catch {
			// The fixed grey stays.
		}
	};

	// Images that loaded before this ran (the eager first slide, or a swapped-in
	// hero) — later ones arrive through the load listener below.
	const sampleLoadedBands = () => {
		gallery?.querySelectorAll("[data-band-sample]").forEach((wrapper) => {
			const image = wrapper.querySelector("img");
			if (image?.complete && image.currentSrc) sampleBandColor(wrapper);
		});
	};

	// `load` does not bubble, so listen in the capture phase.
	document.addEventListener(
		"load",
		(event) => {
			if (!(event.target instanceof HTMLImageElement)) return;
			const wrapper = event.target.closest("[data-band-sample]");
			if (wrapper) sampleBandColor(wrapper);
		},
		true
	);
	sampleLoadedBands();

	// ---------------------------------------------------------------- Lightbox
	// Images are cloned from the active colour slider on open, stacked, and
	// cross-faded. Clicking the active image zooms into the clicked point.
	let lightboxSlider = null;
	let lightboxIndex = 0;
	let lightboxFigures = [];
	let lightboxThumbButtons = [];

	// A slide the shopper never swiped to is still a lazysizes placeholder: class
	// `lazyload`, no `src`, the real URLs parked on data-src / data-srcset
	// (snippets/c-img-srcset.liquid). Cloning one as-is hands the lightbox an
	// image with nothing to paint, and lazysizes cannot rescue it: the clone is
	// inserted while the dialog is still `display: none`, so the view check it
	// runs on that DOM mutation measures an empty box and skips it — and once the
	// dialog is open there is no scroll or resize left to trigger another check.
	// Promote it here instead of waiting for a check that may never come.
	const cloneSlideImage = (slide, sizes) => {
		const image = slide.querySelector("img").cloneNode(true);
		image.removeAttribute("fetchpriority");
		image.removeAttribute("data-sizes");
		// Before srcset, so the candidate is picked against the right slot width.
		image.setAttribute("sizes", sizes);

		if (!image.getAttribute("src") && image.dataset.src) {
			image.src = image.dataset.src;
			if (image.dataset.srcset) image.srcset = image.dataset.srcset;
			image.classList.remove("lazyload");
			image.removeAttribute("data-src");
			image.removeAttribute("data-srcset");
		}

		// A slide lazysizes is still loading carries `lazyloading`, which hides it
		// just like `lazyload` does. lazysizes clears that class on the original
		// when it loads, never on this copy, so the clone would stay blank.
		image.classList.remove("lazyloading");

		return image;
	};

	// Measured against the stack, which never scales. Reading the figure's own
	// rect while it is zoomed feeds the scaled box back into the next origin,
	// which is what made panning jitter.
	const originFromPointer = (event) => {
		const rect = lightboxStack.getBoundingClientRect();
		return {
			x: ((event.clientX - rect.left) / rect.width) * 100,
			y: ((event.clientY - rect.top) / rect.height) * 100,
		};
	};

	// 0%–100% is exactly the pannable range: at 0% the image's left edge sits at
	// the frame's left edge, at 100% its right edge sits at the frame's right.
	// The numbers are kept on the element so a drag can resume from wherever the
	// last one finished without parsing the style back out.
	const applyOrigin = (figure, originX, originY) => {
		const x = Math.min(100, Math.max(0, originX));
		const y = Math.min(100, Math.max(0, originY));
		figure.dataset.originX = x;
		figure.dataset.originY = y;
		figure.style.transformOrigin = `${x}% ${y}%`;
	};

	// The clone is picked from the srcset for a ~100vw slot, but the zoom renders
	// it at ZOOM_SCALE times that, so the browser upscales it and it looks soft.
	//
	// Widening the srcset ladder was the obvious fix and the wrong one: it also
	// let the *gallery* image pick a 3000w candidate on first paint. Instead,
	// re-request the same Shopify CDN asset at exactly the width the zoom needs
	// and swap it in, once per figure. Nothing about the page load, or even
	// opening the lightbox, changes — the larger file is fetched only on zoom,
	// and only when it would actually be an improvement.
	const ZOOM_SCALE = 2;
	const SHOPIFY_MAX_WIDTH = 5760;

	const widthFromUrl = (url) => {
		const match = (url || "").match(/[?&]width=(\d+)/);
		return match ? Number(match[1]) : 0;
	};

	// The width the image is actually painted at, which is not the figure's
	// width. Contained (portrait shots, and every shot on phones), it is the
	// smaller of the figure's width and its height times the image ratio.
	// Covered (landscape shots from tablet up), it is the larger: a 2:1 master
	// in a 1440x900 window is painted 1800px wide. Read from the computed style
	// so this cannot drift from the stylesheet.
	const paintedWidth = (figure, image) => {
		const rect = figure.getBoundingClientRect();
		const imageRatio =
			Number(image.getAttribute("width")) /
			Number(image.getAttribute("height"));
		if (!rect.width || !rect.height || !imageRatio) {
			return rect.width || window.innerWidth;
		}
		const isCover = window.getComputedStyle(image).objectFit === "cover";
		const isFigureNarrower = rect.width / rect.height < imageRatio;
		// Height-bound when a cover image is wider than the figure, or a contain
		// image is narrower; width-bound otherwise.
		return isFigureNarrower === isCover
			? rect.height * imageRatio
			: rect.width;
	};

	const setZoomResolution = (figure) => {
		const image = figure?.querySelector("img");
		if (!image || image.dataset.zoomUpgraded) return;

		const source = image.currentSrc || image.src;
		if (!widthFromUrl(source)) return;

		// Never ask for more than the zoom needs, nor more than the master holds:
		// Shopify does not upscale, so anything past the master is a wasted byte
		// count on a file that comes back the same size anyway.
		const needed = Math.round(
			paintedWidth(figure, image) * (window.devicePixelRatio || 1) * ZOOM_SCALE
		);
		const masterWidth = Number(figure.dataset.masterWidth) || SHOPIFY_MAX_WIDTH;
		const target = Math.min(needed, masterWidth, SHOPIFY_MAX_WIDTH);

		// The candidate already loaded may be big enough — skip the fetch entirely.
		if (target <= widthFromUrl(source)) {
			image.dataset.zoomUpgraded = "true";
			return;
		}

		image.dataset.zoomUpgraded = "true";
		// srcset/sizes would keep overriding src, so retire them for this clone.
		image.removeAttribute("srcset");
		image.removeAttribute("sizes");
		image.src = source.replace(/([?&]width=)\d+/, `$1${target}`);
	};

	const setZoom = (figure, isZoomed, event) => {
		if (!figure) return;
		if (isZoomed && event) {
			const origin = originFromPointer(event);
			applyOrigin(figure, origin.x, origin.y);
		}
		if (isZoomed) setZoomResolution(figure);
		figure.classList.toggle("is-zoomed", isZoomed);
		lightbox.classList.toggle("is-zoomed", isZoomed);
		if (!isZoomed) {
			figure.style.transformOrigin = "";
			delete figure.dataset.originX;
			delete figure.dataset.originY;
		}
	};

	// The lightbox is one background behind every image, so it takes the active
	// image's backdrop grey (see Band colour above), or the stylesheet's fixed
	// grey when that image has none.
	const paintLightbox = () => {
		lightbox?.style.setProperty(
			"--band-color",
			lightboxFigures[lightboxIndex]?.style.getPropertyValue("--band-color") ||
				""
		);
	};

	const setLightboxIndex = (index) => {
		if (index < 0 || index >= lightboxFigures.length) return;
		setZoom(lightboxFigures[lightboxIndex], false);
		lightboxIndex = index;
		lightboxFigures.forEach((figure, figureIndex) => {
			figure.classList.toggle("is-active", figureIndex === index);
		});
		paintLightbox();
		lightboxThumbButtons.forEach((button, buttonIndex) => {
			button.setAttribute(
				"aria-selected",
				buttonIndex === index ? "true" : "false"
			);
		});
		lightboxThumbButtons[index]?.scrollIntoView({
			block: "nearest",
			inline: "nearest",
		});

		// Mobile nav bar (the thumbnail rail is hidden there). Same slot-machine
		// roll as the gallery counter; openLightbox empties the node first so the
		// initial value lands without animating.
		// Zero-padded to the total's width, like the gallery counter — see
		// .c-slider__counter__current in styles/_p-product-hero-2026.scss.
		rollCounterValue(
			lightboxCurrent,
			String(index + 1).padStart(String(lightboxFigures.length).length, "0")
		);
		lightbox
			?.querySelector(".js-pdp-lightbox-prev")
			?.toggleAttribute("disabled", index === 0);
		lightbox
			?.querySelector(".js-pdp-lightbox-next")
			?.toggleAttribute("disabled", index === lightboxFigures.length - 1);
	};

	const openLightbox = (slider, startSlide) => {
		if (!lightbox || !lightboxStack || !lightboxThumbs) return;

		const slides = Array.from(
			slider.querySelectorAll(".js-pdp-hero-2026-slide")
		);
		const imageSlides = slides.filter(
			(slide) =>
				slide.dataset.mediaType === "image" && slide.querySelector("img")
		);
		if (!imageSlides.length) return;

		const startIndex = Math.max(imageSlides.indexOf(startSlide), 0);

		lightboxFigures = imageSlides.map((slide, index) => {
			const figure = document.createElement("figure");
			figure.className = "pdp-lightbox__item";
			figure.dataset.index = index;
			figure.dataset.slideIndex = slides.indexOf(slide);
			if (slide.dataset.masterWidth) {
				figure.dataset.masterWidth = slide.dataset.masterWidth;
			}
			// Carry the slide's backdrop grey over. A slide not read yet (its image
			// never loaded) is read here instead, once the clone loads.
			const slideBand = slide.querySelector("[data-band-sample]");
			const bandColor = slideBand?.style.getPropertyValue("--band-color");
			if (bandColor) {
				figure.style.setProperty("--band-color", bandColor);
				figure.dataset.bandSampled = "true";
			} else if (slideBand) {
				figure.dataset.bandSample = slideBand.dataset.bandSample;
			}
			const slideImage = slide.querySelector("img");
			// Landscape shots fill the lightbox from tablet up; everything else is
			// contained (styles/_p-product-hero-2026.scss).
			if (
				Number(slideImage.getAttribute("width")) >
				Number(slideImage.getAttribute("height"))
			) {
				figure.classList.add("is-landscape");
			}
			// Reuse the gallery's own `sizes` so the clone picks the candidate the
			// gallery already loaded and opens from cache. It is the frame height ×
			// the image ratio (see snippets/product-hero-2026-slide-sizes.liquid),
			// which is at least the width a contained lightbox image is painted at.
			figure.append(
				cloneSlideImage(
					slide,
					slideImage.getAttribute("sizes") ||
						slideImage.dataset.sizes ||
						"100vw"
				)
			);
			return figure;
		});

		// A single image needs no thumbnail rail.
		lightboxThumbButtons =
			imageSlides.length < 2
				? []
				: imageSlides.map((slide, index) => {
						const button = document.createElement("button");
						button.type = "button";
						button.className = "pdp-lightbox__thumb";
						button.setAttribute("role", "tab");
						button.setAttribute("aria-selected", "false");
						button.setAttribute("aria-label", `View image ${index + 1}`);
						button.dataset.index = index;
						button.append(cloneSlideImage(slide, "70px"));
						return button;
					});

		lightboxStack.replaceChildren(...lightboxFigures);
		lightboxThumbs.replaceChildren(...lightboxThumbButtons);

		if (lightboxTotal) lightboxTotal.textContent = imageSlides.length;
		lightboxNav?.style.setProperty(
			"--counter-digits",
			String(imageSlides.length).length
		);
		// Clear so the first setLightboxIndex sets the number instantly rather
		// than rolling from whatever the last session left behind.
		lightboxCurrent?.replaceChildren();
		lightboxNav?.classList.toggle("is-single", imageSlides.length < 2);

		lightboxSlider = slider;
		lightboxIndex = -1;
		setLightboxIndex(startIndex);

		openDialog(lightbox, { trigger: startSlide });
	};

	// Ignore clicks that were really drags on the Embla viewport.
	let pointerDownX = 0;
	let pointerDownY = 0;
	const isDragClick = (event) =>
		Math.hypot(event.clientX - pointerDownX, event.clientY - pointerDownY) > 6;

	on(
		"body",
		"pointerdown",
		".js-pdp-hero-2026-slide, .pdp-lightbox__item",
		(event) => {
			pointerDownX = event.clientX;
			pointerDownY = event.clientY;
		}
	);

	on("body", "click", ".js-pdp-hero-2026-slide", (event, slide) => {
		if (slide.dataset.mediaType !== "image") return;
		if (event.target.closest("a, button")) return;
		if (isDragClick(event)) return;

		const slider = slide.closest(".c-slider");
		if (!slider) return;
		openLightbox(slider, slide);
	});

	// Click the open image to zoom into that point, click again to zoom out.
	on("body", "click", ".pdp-lightbox__item", (event, figure) => {
		if (!figure.classList.contains("is-active")) return;
		if (isDragClick(event)) return;
		setZoom(figure, !figure.classList.contains("is-zoomed"), event);
	});

	// Pan while zoomed, throttled to one update per frame.
	let panFrameId = null;
	let panRequest = null;

	const queuePan = (figure, originX, originY) => {
		panRequest = { figure, originX, originY };
		if (panFrameId) return;
		panFrameId = requestAnimationFrame(() => {
			panFrameId = null;
			if (panRequest) {
				applyOrigin(panRequest.figure, panRequest.originX, panRequest.originY);
			}
		});
	};

	// A touch screen has no hover to pan with, so a zoomed image is dragged
	// instead: the image follows the finger. Scaling about an origin moves the
	// rendered content by (1 - ZOOM_SCALE) times any shift of that origin — the
	// opposite direction, and amplified — so a 1:1 drag has to move the origin by
	// `-delta / (ZOOM_SCALE - 1)`. Anchored to where the finger went down rather
	// than integrated per event, so rounding cannot accumulate over a long drag.
	let panPointerId = null;
	let panStart = null;

	// `|| 50` would be wrong here: an image panned hard against its left or top
	// edge stores a legitimate 0, and the next drag would jump it back to centre.
	const readOrigin = (figure, axis) => {
		const value = Number(figure.dataset[axis]);
		return Number.isFinite(value) ? value : 50;
	};

	const endPan = () => {
		panPointerId = null;
		panStart = null;
	};

	on(
		"body",
		"pointerdown",
		".pdp-lightbox__item.is-zoomed",
		(event, figure) => {
			if (event.pointerType !== "touch") return;
			panPointerId = event.pointerId;
			panStart = {
				clientX: event.clientX,
				clientY: event.clientY,
				originX: readOrigin(figure, "originX"),
				originY: readOrigin(figure, "originY"),
			};
			// Keep receiving the move events once the finger slides off the figure,
			// which it does as soon as the pan reaches an edge.
			figure.setPointerCapture(event.pointerId);
		}
	);

	document.addEventListener("pointerup", endPan);
	document.addEventListener("pointercancel", endPan);

	on(
		"body",
		"pointermove",
		".pdp-lightbox__item.is-zoomed",
		(event, figure) => {
			// Fine pointers keep hovering to pan: the point under the cursor is
			// the origin, which is what the "+" follower is standing on.
			if (event.pointerType !== "touch") {
				const origin = originFromPointer(event);
				queuePan(figure, origin.x, origin.y);
				return;
			}

			if (!panStart || event.pointerId !== panPointerId) return;

			const rect = lightboxStack.getBoundingClientRect();
			const deltaX = ((event.clientX - panStart.clientX) / rect.width) * 100;
			const deltaY = ((event.clientY - panStart.clientY) / rect.height) * 100;
			queuePan(
				figure,
				panStart.originX - deltaX / (ZOOM_SCALE - 1),
				panStart.originY - deltaY / (ZOOM_SCALE - 1)
			);
		}
	);

	on("body", "click", ".pdp-lightbox__thumb", (event, button) => {
		setLightboxIndex(Number(button.dataset.index));
	});

	on("body", "click", ".js-pdp-lightbox-prev", () => {
		setLightboxIndex(lightboxIndex - 1);
	});

	on("body", "click", ".js-pdp-lightbox-next", () => {
		setLightboxIndex(lightboxIndex + 1);
	});

	// Flick between images: a swipe on a touch screen, a drag with the mouse.
	// The image changes on release (the stack cross-fades, it does not slide).
	// A zoomed image is left to the pan above, which owns the same drag.
	// Mostly-vertical drags are ignored, and the active image's
	// `touch-action: pan-y` (styles/_p-product-hero-2026.scss) keeps the browser
	// from claiming the horizontal ones. A mouse drag never reaches the click
	// handler's zoom toggle: isDragClick rejects it.
	const SWIPE_THRESHOLD = 50;
	let swipeStart = null;

	on(
		"body",
		"pointerdown",
		".pdp-lightbox__item.is-active",
		(event, figure) => {
			if (event.button !== 0) return;
			if (figure.classList.contains("is-zoomed")) return;
			swipeStart = {
				pointerId: event.pointerId,
				clientX: event.clientX,
				clientY: event.clientY,
			};
		}
	);

	document.addEventListener("pointerup", (event) => {
		if (!swipeStart || event.pointerId !== swipeStart.pointerId) return;
		const deltaX = event.clientX - swipeStart.clientX;
		const deltaY = event.clientY - swipeStart.clientY;
		swipeStart = null;
		if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;
		if (Math.abs(deltaX) < Math.abs(deltaY)) return;
		setLightboxIndex(lightboxIndex + (deltaX < 0 ? 1 : -1));
	});

	document.addEventListener("pointercancel", () => {
		swipeStart = null;
	});

	// The browser's own image drag would take over a mouse flick and end the
	// pointer stream in `pointercancel`.
	on("body", "dragstart", ".pdp-lightbox__item", (event) => {
		event.preventDefault();
	});

	// Left / right arrow keys step through the images while the lightbox is
	// open. Modified presses are left alone (Alt+Left is browser back).
	document.addEventListener("keydown", (event) => {
		if (!lightbox?.open) return;
		if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
		if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
			return;
		}
		event.preventDefault();
		setLightboxIndex(lightboxIndex + (event.key === "ArrowRight" ? 1 : -1));
	});

	// Sync the gallery to the last image viewed in the lightbox.
	document.addEventListener("bandit:dialog-close", (event) => {
		if (event.target !== lightbox) return;
		setZoom(lightboxFigures[lightboxIndex], false);
		if (!lightboxSlider?.embla) return;
		const slideIndex = Number(
			lightboxFigures[lightboxIndex]?.dataset.slideIndex ?? lightboxIndex
		);
		lightboxSlider.embla.scrollTo(slideIndex, true);
	});

	// ---------------------------------------------------------- "+" cursor
	const initCursor = () => {
		if (!gallery) return;
		if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches)
			return;

		const galleryCursor = document.createElement("div");
		galleryCursor.className = "pdp-cursor";
		galleryCursor.setAttribute("aria-hidden", "true");
		document.body.append(galleryCursor);

		// The lightbox gets its own element (rendered inside the dialog): a
		// showModal() dialog paints in the top layer, above anything left in
		// <body>, so a single shared cursor would be hidden behind it. Looked up
		// per use because a colour swap replaces the lightbox.
		const getLightboxCursor = () =>
			lightbox?.querySelector(".pdp-lightbox__cursor");
		const getCursors = () =>
			[galleryCursor, getLightboxCursor()].filter(Boolean);

		let cursorX = 0;
		let cursorY = 0;
		let frameId = null;
		let activeCursor = null;

		// `translate`, not `transform`: see the note on .pdp-cursor in
		// styles/_p-product-hero-2026.scss — a transform translate composes before
		// `scale` and gets scaled with it, dragging the cursor toward the corner.
		const positionCursor = (cursor) => {
			cursor.style.translate = `${cursorX}px ${cursorY}px`;
		};

		const renderCursor = () => {
			frameId = null;
			getCursors().forEach(positionCursor);
		};

		const setActiveCursor = (target, isZoomed) => {
			// Move the cursor to the pointer *before* revealing it. Otherwise it
			// scales in at wherever it was last left and then jumps across, which
			// reads as sliding in from a random spot.
			if (target && target !== activeCursor) positionCursor(target);

			getCursors().forEach((cursor) => {
				cursor.classList.toggle("is-active", cursor === target);
				cursor.classList.toggle("is-zoom-out", cursor === target && isZoomed);
			});
			activeCursor = target;
		};

		document.addEventListener("pointermove", (event) => {
			const isOverControl = Boolean(event.target.closest("a, button"));
			const isDragging = Boolean(
				event.target.closest(".embla__viewport.is-dragging")
			);
			const lightboxImage = event.target.closest(
				".pdp-lightbox__item.is-active"
			);
			const gallerySlide = event.target.closest(
				'.js-pdp-hero-2026-slide[data-media-type="image"]'
			);

			let target = null;
			if (lightbox?.open) {
				if (lightboxImage && !isOverControl) target = getLightboxCursor();
			} else if (gallerySlide && !isOverControl && !isDragging) {
				target = galleryCursor;
			}

			cursorX = event.clientX;
			cursorY = event.clientY;

			setActiveCursor(
				target,
				Boolean(lightboxImage?.classList.contains("is-zoomed"))
			);

			if (!frameId) frameId = requestAnimationFrame(renderCursor);
		});

		document.addEventListener("pointerdown", () =>
			activeCursor?.classList.add("is-pressed")
		);
		document.addEventListener("pointerup", () =>
			getCursors().forEach((cursor) => cursor.classList.remove("is-pressed"))
		);
	};
	initCursor();

	// ------------------------------------------------- Selected variant label
	// The shared cItemVariants script rewrites data-label-current on hover, but
	// the colour swatches already have their own tooltip. Print a separate
	// attribute that only ever reflects the checked input, so hovering does not
	// change the label. JS-only on purpose: the same span renders in cart line
	// items and upsell items, which must keep their existing behaviour.
	const syncSelectedVariantLabels = () => {
		hero?.querySelectorAll(".js-variant-pills-selected").forEach((label) => {
			const group = label.closest(".js-variant-group");
			const checked = group?.querySelector(".js-variant-selector:checked");
			// Print the option value exactly as written in Shopify admin ("NY Navy"
			// stays "NY Navy"); the radio value is the raw option value.
			label.dataset.labelSelected = checked?.value || "";
		});
	};

	syncSelectedVariantLabels();
	document.addEventListener("change", (event) => {
		if (!event.target.closest(".c-product-form .js-variant-selector")) return;
		setTimeout(syncSelectedVariantLabels, 0);
	});

	// ------------------------------------------------------------ Low stock
	// c-item-variants renders this line empty (opt-in via `show_low_stock`); fill
	// it from the form's data-variants-json, which already carries per-variant
	// inventory. Threshold matches the one hard-coded in c-item-card (5).
	const updateLowStock = () => {
		const lowStockNode = hero?.querySelector(".js-variant-low-stock");
		if (!lowStockNode) return;

		const variantForm = hero.querySelector(".c-product-form");
		const lowStockThreshold =
			Number(lowStockNode.dataset.lowStockThreshold) || 5;

		let variantData = [];
		try {
			variantData = JSON.parse(
				variantForm.dataset.variantsJson.replace(/'/g, '"')
			);
		} catch (error) {
			variantData = [];
		}

		const variantId = variantForm.querySelector('[name="id"]')?.value;
		const variant = variantData.find(
			(item) => String(item.id) === String(variantId)
		);
		const inventory = variant ? Number(variant.inventory) : 0;

		if (!variant || inventory < 1 || inventory > lowStockThreshold) {
			lowStockNode.textContent = "";
			return;
		}

		const sizeName = (variant.sizeName || "").trim();
		lowStockNode.textContent = sizeName
			? `${sizeName} - Only ${inventory} remaining`
			: `Only ${inventory} remaining`;
	};

	updateLowStock();
	document.addEventListener("change", (event) => {
		if (!event.target.closest(".c-product-form .js-variant-selector")) return;
		setTimeout(updateLowStock, 0);
	});

	// ------------------------------------------------------------ Review stars
	// Stamped's badge endpoint returns the same group-pooled rating and count as
	// the reviews widget lower down; the metafields the slot was rendered from
	// are per product and drift. Rebuild the stars from it (same markup as
	// snippets/c-product-review-stars.liquid) and only then reveal the slot. If
	// the call fails or is slow, reveal the metafield stars instead. Sibling
	// colourways share a group, so a swap back reuses the cached answer.
	const REVIEW_TIMEOUT_MS = 1500;
	const reviewSummaries = new Map();

	const fetchReviewSummary = async (productId, storeUrl) => {
		if (reviewSummaries.has(productId)) return reviewSummaries.get(productId);

		const apiKey = document.getElementById("stamped-script-widget")?.dataset
			.apiKey;
		if (!apiKey) throw new Error("Stamped API key not found");

		const response = await fetch(
			"https://stamped.io/api/widget/badges?isIncludeBreakdown=false&isincludehtml=false",
			{
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ productIds: [{ productId }], apiKey, storeUrl }),
				signal: AbortSignal.timeout(REVIEW_TIMEOUT_MS),
			}
		);
		if (!response.ok) throw new Error(`Stamped badges: ${response.status}`);

		const [badge] = await response.json();
		const summary = {
			rating: Number(badge?.rating) || 0,
			count: Number(badge?.count) || 0,
		};
		reviewSummaries.set(productId, summary);
		return summary;
	};

	const buildReviewStars = (slot, rating, count) => {
		const starTemplate = slot.querySelector(".js-pdp-hero-2026-reviews-star");
		const fullCount = Math.floor(rating);
		const fraction = Math.round((rating - fullCount) * 100);
		const gradientId = `star-gradient-${fraction}-live-${slot.dataset.productId}`;
		const scoreLabel = rating.toFixed(1);

		const stars = document.createElement("span");
		stars.className = "c-product-review-stars__stars f-h f-nw f-a-c";
		stars.setAttribute("role", "img");
		stars.setAttribute(
			"aria-label",
			`Rated ${scoreLabel} out of 5 stars from ${count} reviews`
		);

		if (fraction > 0) {
			stars.insertAdjacentHTML(
				"beforeend",
				`<svg class="c-product-review-stars__defs" aria-hidden="true"><defs><linearGradient id="${gradientId}"><stop class="c-product-review-stars__stop-full" offset="0%"/><stop class="c-product-review-stars__stop-full" offset="${fraction}%"/><stop class="c-product-review-stars__stop-empty" offset="${fraction}%"/><stop class="c-product-review-stars__stop-empty" offset="100%"/></linearGradient></defs></svg>`
			);
		}

		for (let i = 0; i < 5; i++) {
			const star = starTemplate.content.firstElementChild.cloneNode(true);
			if (i === fullCount && fraction > 0) {
				star.setAttribute("fill", `url(#${gradientId})`);
			} else if (i >= fullCount) {
				star.classList.add("is-empty");
			}
			stars.append(star);
		}

		const link = document.createElement("a");
		link.href = slot.dataset.reviewAnchor;
		link.className =
			"c-product-review-stars f-h f-nw f-a-c f-j-s product-hero-2026__reviews";
		link.innerHTML = `<span class="c-product-review-stars__score t-l-2">${scoreLabel} (${count})</span><span class="c-product-review-stars__cta t-l-2">Read reviews</span>`;
		link.prepend(stars);

		return link;
	};

	const updateReviewStars = async () => {
		const slot = hero?.querySelector(".js-pdp-hero-2026-reviews");
		if (!slot) return;

		try {
			const { rating, count } = await fetchReviewSummary(
				slot.dataset.productId,
				slot.dataset.storeUrl
			);
			// The fallback goes either way: stale stars are never shown, and a group
			// whose reviews were all removed keeps an empty slot.
			slot.querySelector(".c-product-review-stars")?.remove();
			if (count > 0) slot.prepend(buildReviewStars(slot, rating, count));
		} catch (error) {
			console.warn("Live review stars unavailable:", error);
		}

		slot.classList.add("is-ready");
	};
	updateReviewStars();

	// ------------------------------------------------------- Related rail
	// "Wear it with" under the accordions. Curated picks arrive server-rendered;
	// otherwise fetch Shopify's recommendations once the rail nears the viewport,
	// falling back from "complementary" to "related" like
	// sections/products-related.liquid. Hidden when nothing comes back.
	let relatedObserver = null;

	const loadRelatedCards = (url) =>
		fetch(url)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement("div");
				html.innerHTML = text;
				return Array.from(html.querySelectorAll(".c-item-card"));
			});

	const initRelatedRail = () => {
		relatedObserver?.disconnect();

		const relatedRail = hero?.querySelector(".js-pdp-related-rail");
		if (!relatedRail || relatedRail.querySelector(".c-item-card")) return;

		const hideRail = () => relatedRail.classList.add("is-hidden");
		const { url, fallbackUrl } = relatedRail.dataset;
		if (!url) {
			hideRail();
			return;
		}

		relatedObserver = new IntersectionObserver(
			(entries) => {
				if (!entries[0].isIntersecting) return;
				relatedObserver.disconnect();

				loadRelatedCards(url)
					.then((cards) =>
						cards.length || !fallbackUrl ? cards : loadRelatedCards(fallbackUrl)
					)
					.then((cards) => {
						// A colour swap may have replaced the rail meanwhile.
						if (!relatedRail.isConnected) return;
						if (!cards.length) {
							hideRail();
							return;
						}
						relatedRail
							.querySelector(".js-pdp-related-rail-content")
							.replaceChildren(...cards);
						if (window.lazySizes) window.lazySizes.loader.checkElems();
					})
					.catch((error) => {
						console.error("Failed to load related products:", error);
						hideRail();
					});
			},
			{ rootMargin: "0px 0px 200px 0px" }
		);
		relatedObserver.observe(relatedRail);
	};
	initRelatedRail();

	// ------------------------------------------------------------ Colour swap
	// The new hero arrives server-rendered for its own product; refresh what this
	// script filled in by hand on load.
	document.addEventListener("bandit:product-swapped", () => {
		bindHeroNodes();
		if (!hero) return;

		if (window.lazySizes) {
			window.lazySizes.loader.checkElems();
		}
		sampleLoadedBands();
		syncSelectedVariantLabels();
		updateLowStock();
		updateReviewStars();
		initRelatedRail();
	});
};

initProductHero2026();
